import { FormattedMessage as FM } from "react-intl";

function ListFieldHint({ id }) {
  if (!id) return null;
  return (
    <p className="mt-1 text-xs text-neutral-500">
      <FM id={id} />
    </p>
  );
}

export default ListFieldHint;
